import { Box } from '@factorialco/deprecated-design-system'

import { PrejoinCameraButton } from './components/PrejoinCameraButton'
import { PrejoinMicrophoneButton } from './components/PrejoinMicrophoneButton'
import { PrejoinSettingsButton } from './components/PrejoinSettingsButton'

interface PrejoinControlBarProps {
  onVideoEnabledChange: (enabled: boolean) => void
  onVideoDeviceIdChange: (deviceId: string) => void
  onBackgroundTypeChange: (backgroundType: string) => void
}
export const PrejoinControlBar = ({
  onVideoEnabledChange,
  onVideoDeviceIdChange,
  onBackgroundTypeChange,
}: PrejoinControlBarProps) => {
  return (
    <Box
      alignItems="center"
      flexDirection="row"
      gap="s8"
      position="relative"
      justifyContent="center"
    >
      <PrejoinMicrophoneButton />
      <PrejoinCameraButton onVideoEnabledChange={onVideoEnabledChange} />
      <PrejoinSettingsButton
        onVideoDeviceIdChange={onVideoDeviceIdChange}
        onBackgroundTypeChange={onBackgroundTypeChange}
      />
    </Box>
  )
}
